import { EnvConfig } from "..";

const config: EnvConfig = {
  basketBFFBaseUrl: "https://api.integration.project4.com/basket-ui",
  socialProofApi:
    "https://api.integration.project4.com/product-badging/api/v1/social-proof-messaging",
  onlineStockBaseUrl:
    "https://api.integration.project4.com/online-stock/v2/available-stock",
  // deepcode ignore HardcodedNonCryptoSecret
  onlineStockApiKey: "AIzaSyA1LzkNrQFvBj0CAwl6X1vfCqP8lrJuMIY",
};

export default config;
